import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '@/views/layout/Layout'

Vue.use(Router)

/**
* hidden: true                   如果 `hidden:true` 则不会在侧边栏sidebar中显示 (default is false)
* alwaysShow: true               如果设置这个为true 则始终显示根菜单，无论它子路由的长度是多少都不显示
*                                如果没设置alwaysShow这个属性，则子级下只能有一个以上的路由，它就会成为嵌套模式，不然就不显示根菜单

* redirect: noredirect           如果这样设置 `redirect:noredirect` 面包屑breadcrumb中不会重定向
* name:'router-name'             name这个属性由 <keep-alive> 使用  (必须设置！！！)
* meta : {
    title: 'title'               子菜单和面包屑中显示的名称
    icon: 'svg-name'             图标显示在侧边栏sidebar中
    breadcrumb: false            如果为false，则该项将隐藏在breadcrumb中(default is true)
  }
**/
export const constantRouterMap = [
  {
    path: '/',
    component: Layout, // 最大的容器
    redirect: 'index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/index/index'),
        name: 'index',
        meta: { title: '首页', icon: 'ant-design:home-twotone' }
      }
    ]
  },
  { // 一级菜单
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '/appointment',
    component: Layout,
    redirect: '/appointment',
    meta: { title: '会议预约', icon: 'fluent:device-meeting-room-remote-16-regular' },
    hidden: false,
    children: [
      {
        path: 'conferencebooking',
        component: () => import('@/views/conferencebooking/conferencebooking'),
        name: 'conferencebooking',
        meta: { title: '会议预约', icon: 'healthicons:group-discussion-meetingx3-outline' }
      },
      {
        path: 'appointment',
        hidden: true,
        component: () => import('@/views/conferencebooking/appointment.vue'),
        name: 'appointment',
        meta: { title: '会议预约详情', icon: 'tabler:list-details' }
      },
      {
        path: 'template',
        component: () => import('@/views/template'),
        name: 'template',
        meta: { title: '会议预约模板', icon: 'tabler:template' }
      }

    ]
  },
  {
    path: '/morningList',
    component: Layout,
    redirect: '/morningList',
    meta: { title: '早晚会', icon: 'icon-park-outline:plan' }, // 一级菜单
    children: [
      {
        path: 'index',
        component: () => import('@/views/morningMeeting/morningList.vue'),
        name: 'morningList',
        meta: { title: '早晚会', icon: 'material-symbols:add-notes-outline-rounded' }, // 二级菜单
        hidden: false
      },
      {
        path: 'morningTask',
        component: () => import('@/views/morningMeeting/morningTask.vue'),
        name: 'morningTask',
        meta: { title: '早晚会任务', icon: 'material-symbols:mark-unread-chat-alt-outline-rounded' },
        hidden: false
      },
      {
        path: 'morningDetails',
        component: () => import('@/views/morningMeeting/morningDetails.vue'),
        name: 'morningDetails',
        meta: { title: '早晚会详情', icon: 'dashboard' },
        hidden: true
      },
      {
        path: 'endemetts',
        component: () => import('@/views/conferencebooking/endemett.vue'),
        name: 'endemetts',
        meta: { title: '编辑会议', icon: 'dashboard' },
        hidden: true
      }
    ]
  },
  {
    path: '/conferenceStatusTask',
    component: Layout,
    // redirect: '/conferenceStatus',
    meta: { title: '大杂会', icon: 'ic:round-auto-awesome-motion' },
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/conferenceStatus/index'),
        name: 'conferenceStatus',
        meta: { title: '大杂会', icon: 'tabler:message-code' },
        hidden: false
      },
      {
        path: 'myTaskList',
        component: () => import('@/views/myTaskList/index'),
        name: 'myTaskList',
        meta: { title: '大杂会任务', icon: 'jam:task-list' },
        hidden: false
      },
      {
        path: 'seeDetails',
        component: () => import('@/views/conferenceStatus/seeDetails.vue'),
        name: 'seeDetails',
        meta: { title: '会议详情', icon: 'dashboard' },
        hidden: true
      },
      {
        path: 'endemett',
        component: () => import('@/views/conferencebooking/endemett.vue'),
        name: 'endemett',
        meta: { title: '编辑会议', icon: 'dashboard' },
        hidden: true
      }
    ]
  },
  {
    path: '/score', // 依照原系统配置菜单，丢在了外面
    component: Layout,
    redirect: '/score',
    hidden: true,
    children: [
      {
        path: 'score',
        component: () => import('@/views/conferenceStatus/score'),
        name: 'score',
        meta: { title: '评分', icon: 'dashboard' },
        hidden: false
      }
    ]
  },
  {
    path: '/secretaryList', // 秘书部门列表页
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/secretarylist/index'),
        name: '部门秘书关系',
        meta: { title: '部门秘书关系' },
        hidden: true
      }
    ]
  },
  {
    path: '/personCount', // 个人统计报表
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/count/details'),
        name: 'personCount',
        meta: { title: '个人统计报表' },
        hidden: true
      }
    ]
  },
  {
    path: '/seatManage', // 座位图
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/seatManage/seatPlan'),
        name: 'seatManage',
        meta: { title: '座位图', icon: 'dashboard' },
        hidden: true
      }
    ]
  }
]

export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const routerMap = {
  conferencebooking: () => import('@/views/conferencebooking/conferencebooking'),
  editMeeting: () => import('@/views/editMeeting'),
  equipmentConfiguration: () => import('@/views/equipmentConfiguration'),
  meetingType: () => import('@/views/meetingType'),
  deliver: () => import('@/views/deliver'),
  template: () => import('@/views/template'),
  mettingManagement: () => import('@/views/mettingManagement'),
  cityList: () => import('@/views/cityList'),
  // conferenceStatus: () => import('@/views/conferenceStatus'),// 因为是全部人都有的，暂时不需要配置，注释，如需动态配置正式上此菜单
  scoringDimension: () => import('@/views/scoringDimension'),
  morningList: () => import('@/views/morningMeeting/morningList'),
  morningTask: () => import('@/views/morningMeeting/morningTask'),
  // seeDetails: () => import('@/views/conferenceStatus/seeDetails'),
  // myTaskList: () => import('@/views/myTaskList'),
  departmentManage: () => import('@/views/departmentManage'),
  secretaryConf: () => import('@/views/secretary/index'),
  cancelReason: () => import('@/views/cancelReason/index'),
  count: () => import('@/views/count/countList')
  // test: () => import('@/views/test/index')
}
